import React, { useEffect, useState } from 'react';
import images from '../images';

const MobileLogoBlock = () => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => prev - 180);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mobile-app-header__brand-block">
      <div className="logo-container">
        <img
            src={images.logo}
            alt="Логотип"
            className="logo-image"
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: 'transform 1s ease-in-out'
            }}
        />
        <span className="logo-text">ПАРТНЕР ЛИДС</span>
      </div>
    </div>
  );
};

export default MobileLogoBlock;
